import { ReactNode, useContext, useMemo, useState } from 'react'
import { Collapse } from 'ui'
import { TextInputProps } from 'ui/src/components/controls/text-input'
import { UgeLayersContext } from '../../../contexts/layers'
import { CaptionLayer } from '../../../types'
import Input from './input'

type Props = {
    active?: boolean
    caption: CaptionLayer
    children?: ReactNode
    className?: string
    showAdd?: boolean
    onExpand?: (captionId: string) => void
}

const CaptionsEditorCaption = ({ active = false, caption, children, className, showAdd = false, onExpand }: Props) => {
    const { setActiveLayerId } = useContext(UgeLayersContext)
    const [autoFocus, setAutoFocus] = useState<boolean>(false)

    const textInputOptions: Partial<TextInputProps> = useMemo(
        () => ({
            autoFocus,
            selectOnFocus: true,
            onBlur: () => {
                setActiveLayerId(undefined)
            },
            onFocus: () => {
                onExpand?.(caption.id)
                setActiveLayerId(caption.id)
            },
        }),
        [autoFocus, caption.id]
    )

    const onCollapseChange = (isOpen: boolean) => {
        if (isOpen) {
            onExpand?.(caption.id)
        }
    }

    const onCollapseTransitionEnd = () => {
        setAutoFocus(active)
    }

    return (
        <Collapse
            className={className}
            label={
                <Input caption={caption} textInputOptions={textInputOptions} onAdd={showAdd ? onExpand : undefined} />
            }
            open={active}
            size="medium"
            onChange={onCollapseChange}
            onTransitionEnd={onCollapseTransitionEnd}
        >
            {children}
        </Collapse>
    )
}

export default CaptionsEditorCaption
